import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services/modules/common.service';
import { CommonOptions, DaneCity, SecurityReference, SecurityReferences } from '../../../interfaces/interfaces';
import { environment } from 'src/environments/environment';
import { SnackBarService } from '../../../services/utils/snackBar.service';
import { DialogService } from '../../../services/utils/dialog.service';
import {User, UserInfo} from 'src/app/core/models/User';
import { EmployerPost } from 'src/app/core/models/Employer/Employer';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { TypeSecurityReference } from 'src/app/core/constants/type-security-references';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FilterMultipleService } from 'src/app/core/services/utils/filter-multiple.service';
import { UtilService } from 'src/app/core/services/utils/utils.service';
import {AuthGuardService} from '../../../services/guards/AuthGuardService';

export interface DialogData {
  data: any;
  DocumentType: string;
  DocumentNumber: string;
  personal: any;
  digito: any;
  CompanyInfoParentId: any;

}

export interface viewshowChips {
  Id: number;
  Name: string;
}

@Component({
  selector: 'app-dialog-create-employer',
  templateUrl: './dialog-create-employer.component.html',
  styleUrls: ['./dialog-create-employer.component.scss']
})

export class DialogCreateEmployerComponent implements OnInit {
  userInfo: User;
  formDataPhoto: FormData;
  formEmployer: FormGroup;
  employer: EmployerPost;

  digito: string;
  s3Bucket: string;
  documentType: string;
  visible = true;
  imgCropperResult: string;
  removable = true;
  selectable = true;
  documentNumber = '';
  flagValidNit = true;

  maxCaracter = 15;
  maxCaracterRol = 50;

  daneCity: DaneCity[] = [];
  viewValues: string[] = [];
  securityReferences: any = [];
  arl: SecurityReference[] = [];
  companyDocumentType: CommonOptions[] = [];
  CajadeCompensacionObs: SecurityReferences[];
  CajadeCompensacion: SecurityReferences[] = [];
  selectedIdCajadeCompensacion: viewshowChips[] = [];

  control = new FormControl();

  @ViewChild('InputControl') InputControl: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    public dialogRef: MatDialogRef<DialogCreateEmployerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private authService: AuthGuardService,
    private commonService: CommonService,
    private snackBService: SnackBarService,
    private dialogService: DialogService,
    private employerService: EmployerService,
    private filters: FilterMultipleService,
    private utilService: UtilService
  ) {
    // Select Chip inicialicacion de valores
    this.control.valueChanges.subscribe(value => {
    value !== '' ?
    this.CajadeCompensacionObs = this._filter(value) :
    this.CajadeCompensacionObs = this.CajadeCompensacion.slice(); });
  }

  ngOnInit(): void {
    setTimeout(() => this.servicesEmployerAll(), 300);
    this.s3Bucket = environment.api.s3Bucket;

    this.formEmployer = this.fb.group({
      Address: '',
      ArlId: 81,
      CityCode: '',
      CompanyInfoParentId: new FormControl('', Validators.required),
      DocumentNumber: new FormControl('', Validators.required),
      DocumentType: new FormControl('', Validators.required),
      Email: '',
      Name: new FormControl('', Validators.required),
      Phone: '',
      Rol: new FormControl('', Validators.required),
      ServicesProvided: '',
      Website: '',
      IsExempt: false,
    });
    if (this.data.data) {
      if (this.data.DocumentType === 'CC') {
        this.formEmployer.get('DocumentType').setValue(this.data.DocumentType);
        this.formEmployer.get('DocumentNumber').setValue(this.data.DocumentNumber);
        this.formEmployer.get('Name').setValue(this.data.DocumentNumber);
        this.formEmployer.get('Name').disable();
      } else if (this.data.DocumentType === 'NIT') {
        this.formEmployer.get('DocumentType').setValue(this.data.DocumentType);
        this.formEmployer.get('DocumentNumber').setValue(this.data.DocumentNumber);
        this.formEmployer.get('Name').setValue(this.data.data.Name);
        this.formEmployer.get('Name').disable();
        this.documentNumber = this.data.DocumentNumber;
        this.documentType = this.data.DocumentType;
        this.digito = this.data.digito;
      }
    }
    if (this.data.DocumentNumber && this.data.DocumentType === 'CC') {
      this.formEmployer.get('DocumentType').setValue(this.data.DocumentType);
      this.formEmployer.get('DocumentNumber').setValue(this.data.DocumentNumber);
      this.documentNumber = this.data.DocumentNumber;
      this.documentType = this.data.DocumentType;
    }
    if (this.data.DocumentNumber && this.data.DocumentType === 'NIT') {
      this.formEmployer.get('DocumentType').setValue(this.data.DocumentType);
      this.formEmployer.get('DocumentNumber').setValue(this.data.DocumentNumber);
      this.documentNumber = this.data.DocumentNumber;
      this.documentType = this.data.DocumentType;
      this.digito = this.data.digito;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  servicesEmployerAll() {
    this.userInfo = this.authService.auth.getUser();
    this.commonService.getCommonOptions('CompanyDocumentType').subscribe((data: CommonOptions[]) => {
      this.companyDocumentType = data.filter(documents => documents.Value === 'NIT' || documents.Value === 'CC')
          .sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.employerService.getSecurityReferences().subscribe((data: any) => {
      this.arl = data.filter(x => x.Type === TypeSecurityReference.ARL).sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.commonService.getTypeSecurityReferences(3).subscribe(rest => {
      this.CajadeCompensacion = rest;
      this.CajadeCompensacionObs = rest;
    });
    this.commonService.getDaneCity().subscribe((daneCity: DaneCity[]) => {
      this.daneCity = daneCity;
    });
  }

  updatePhotoEmployer() {
    const adminId = this.data?.CompanyInfoParentId || '';
    this.dialogService.openDialogGestorImg('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true,
      undefined, false, false, adminId).afterClosed().subscribe((result: any) => {
      if (!result) {return; }

      const MAX = 10_000_000;
      const isFormData = (x: any): x is FormData => x && typeof x.append === 'function' && typeof x.get === 'function';
      const original = result?.meta?.originalBytes as number | undefined;

      if (typeof original === 'number' && original > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }

      const fd: FormData = isFormData(result) ? result : isFormData(result?.FormData) ? result.FormData : null;
      if (!fd) { return; }

      const fileOrBlob = fd.get('File') as File | Blob | null;
      if (!fileOrBlob) { return; }

      if (fileOrBlob.size > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }
      this.imgCropperResult = result.imgResult;
      this.formDataPhoto = fd;
    });
  }

  onSubmit() {
    this.formEmployer.get('CompanyInfoParentId').setValue(this.data.CompanyInfoParentId);
    if (this.formEmployer.status === 'VALID') {
      this.employer = {
        Address: this.formEmployer.get('Address').value,
        ArlId: this.formEmployer.get('ArlId').value,
        CityCode: this.formEmployer.get('CityCode').value,
        CompanyInfoParentId: this.formEmployer.get('CompanyInfoParentId').value,
        DocumentNumber: this.documentType === 'NIT' ? this.formEmployer.get('DocumentNumber').value
          + '-' + this.digito : this.formEmployer.get('DocumentNumber').value,
        DocumentType: this.formEmployer.get('DocumentType').value,
        Email: this.formEmployer.get('Email').value,
        Name: this.formEmployer.get('Name').value,
        Phone: this.formEmployer.get('Phone').value,
        Rol: this.formEmployer.get('Rol').value,
        ServicesProvided: this.formEmployer.get('ServicesProvided').value,
        Website: this.formEmployer.get('Website').value,
        IsExempt: this.formEmployer.get('IsExempt').value
      };
      const CCFId: number[] = [];
      this.selectedIdCajadeCompensacion.forEach(selectedCaja => {
        CCFId.push(selectedCaja.Id);
      });
      this.employerService.postEmployer(this.employer).subscribe((employer: EmployerPost) => {
        if (this.formDataPhoto === undefined) {
          if (CCFId.length === 0) {
            this.dialogRef.close(employer);
          } else {
            this.employerService.postAddCCFemployerId(employer.CompanyInfoParentId, CCFId).subscribe(restAddCCF => {
              this.dialogRef.close(employer);
            });
          }
        } else {
          this.employerService.putEmloyerUpdateLogo(employer.Id, this.formDataPhoto).subscribe((rest: any) => {
            if (CCFId.length === 0) {
              this.dialogRef.close(employer);
            } else {
              this.employerService.postAddCCFemployerId(employer.CompanyInfoParentId, CCFId).subscribe(restAddCCF => {
                this.dialogRef.close(employer);
              });
            }
          });
        }
      });
    } else {
      this.snackBService.openWarning('Completar los campos requeridos', '', 4000);
    }
  }

  validateNit() {
    if ((this.documentType === 'NIT') && (this.documentNumber !== '' && this.digito !== undefined)) {
      if (parseInt(this.digito, 10) !== this.utilService.calcularDigito(this.documentNumber)) {
        this.flagValidNit = false;
      } else {
        this.flagValidNit = true;
      }
    }
  }

  setValuePersonal() {
    this.documentNumber = '';
    this.documentType = 'NIT';
  }

  // Metodos Selected Chip / en el Constructor se inicia los array con el change Input
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.viewValues.push(value);
    }
    this.control.setValue(null);
  }

  remove(item: string): void {
    const index = this.viewValues.indexOf(item);
    const compIndex = this.selectedIdCajadeCompensacion.findIndex((comp) => comp.Name === item);

    if (compIndex >= 0) {
      this.selectedIdCajadeCompensacion.splice(compIndex, 1);
    }

    if (index >= 0) {
      this.viewValues.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const exitCaja = this.selectedIdCajadeCompensacion.find(x => x.Id === event.option.value);
    if (this.selectedIdCajadeCompensacion.length === 0 || exitCaja === undefined) {
      this.selectedIdCajadeCompensacion.push({Id: event.option.value, Name: event.option.viewValue});
      this.viewValues.push(event.option.viewValue);
      this.InputControl.nativeElement.value = '';
      this.InputControl.nativeElement.disabled = true;
      this.control.setValue('');
      this.InputControl.nativeElement.disabled = false;
    } else {
      this.InputControl.nativeElement.value = '';
      this.InputControl.nativeElement.disabled = true;
      this.control.setValue('');
      this.InputControl.nativeElement.disabled = false;
    }
  }

  private _filter(value: string): SecurityReferences[] {
    return this.CajadeCompensacion.filter(x => {
      return  this.filters.exitFilter(x.Name , value);
    });
  }
  // Metodos Selected Chip / en el Constructor se inicia los array con el change Input FIn
}
